export const IntegrationMapItemCode = Object.freeze({
	YANDEX: 'yandex',
	GIS: 'gis',
});

export const IntegrationMapItemStatus = Object.freeze({
	CONNECTED: 'connected',
	NOT_CONNECTED: 'not_connected',
	IN_PROGRESS: 'in_progress',
});
